import { render, staticRenderFns } from "./SingleOrderDetails.vue?vue&type=template&id=afeadb68&scoped=true"
import script from "./SingleOrderDetails.vue?vue&type=script&lang=js"
export * from "./SingleOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./SingleOrderDetails.vue?vue&type=style&index=0&id=afeadb68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeadb68",
  null
  
)

export default component.exports